module.exports = __webpack_public_path__ + "img/certificate-background.851d82a6.jpg";